export const SORT_PARAMS = [
  { id: 1, value: "-created_at", label: "Newest First" },
  { id: 2, value: "created_at", label: "Oldest First" },
  { id: 3, value: "name", label: "Name (A-Z)" },
  { id: 4, value: "-name", label: "Name (Z-A)" },
  { id: 5, value: "fee", label: "Fee (Low to High)" },
  { id: 6, value: "-fee", label: "Fee (High to Low)" },
]

export const BUNDLE_SORT_PARAMS = [
  { id: 1, value: "-created_at", label: "Newest First" },
  { id: 2, value: "created_at", label: "Oldest First" },
  { id: 3, value: "name", label: "Name (A-Z)" },
  { id: 4, value: "-name", label: "Name (Z-A)" },
  { id: 5, value: "price", label: "Fee (Low to High)" },
  { id: 6, value: "-price", label: "Fee (High to Low)" },
]

export const FILTER_PARAMS = [
  { id: 1, value: "", label: "All" },
  { id: 2, value: "inprogress", label: "In Progress" },
  { id: 3, value: "completed", label: "Completed" },
  { id: 4, value: "notstarted", label: "Not Started" },
]

export const SORT_COURSES = [
  { id: 1, value: "-date_enrolled", label: "Newest First" },
  { id: 2, value: "date_enrolled", label: "Oldest First" },
  { id: 3, value: "course_name", label: "Name (A-Z)" },
  { id: 4, value: "-course_name", label: "Name (Z-A)" },
  { id: 5, value: "progress", label: "Progress (0%-100%)" },
  { id: 6, value: "-progress", label: "Progress (100%-0%)" },
]

export const SORT_CERTIFICATES = [
  { id: 1, value: "-timestamp", label: "Newest First" },
  { id: 2, value: "timestamp", label: "Oldest First" },
  { id: 3, value: "course__name", label: "Name (A-Z)" },
  { id: 4, value: "-course__name", label: "Name (Z-A)" },
]
